import { Box, Skeleton } from '@mui/material';

import { FC } from 'react';

export const FilterSkeleton: FC = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
      <Skeleton
        sx={{ marginInlineEnd: 1 }}
        variant='rectangular'
        width={10}
        height={10}
      />
      <Skeleton variant='rectangular' width='100%' height={10} />
    </Box>
  );
};

export default FilterSkeleton;
